import React from 'react';
import PropTypes from 'prop-types';
import { Timeline } from 'react-twitter-widgets';
import { Row, Col } from 'react-bootstrap';

const Props = {
    twitterUsername: PropTypes.string.isRequired
};

const TwitterTimeline = ({ twitterUsername }) => {
    const url = `https://twitter.com/${twitterUsername}`;

    return (
        <Row className="speaker-twitter">
            <div className="speaker-section-notch custom-color color-1-background"></div>
            <Col lg={10} lgOffset={1}>
                <h1 className="tweets-activity-title text-ellipsis bz-bold custom-font  margin-left-small margin-right-small">Tweets Activity</h1>
                <Row>
                    <Col lg={12}>
                        <div className="speaker-twitter-timeline-wrapper">
                            <Timeline
                                dataSource={{
                                    sourceType: 'profile',
                                    screenName: twitterUsername
                                }}
                                options={{
                                    theme: 'light',
                                    chrome: 'noheader nofooter',
                                    id: `profile:${twitterUsername}`
                                }}
                            />
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

TwitterTimeline.propType = Props;

export default TwitterTimeline;
